import React, {useState} from 'react';
import 'contents/assets/scss/page/mypage.scss';
import Calendar from '../../../component/Inc/Calendar';
import PopRequestPoint from '../../mypage/_PopRequestPoint';

function AccountingIncentiveCheckDetail() {
  const [isOrderActive1, setIsOrderActive1] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <main className="com_container com_salary">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
				<h2 className='com_pg_tit icon menu12_8'>인센티브 명세서 <span className="bar"/><span className="point_txt">김홍보403</span></h2>

          <div className="com_btn_wrap">
            <button onClick={() => setModalOpen(true)} className="com_btn orange s btn_plus">
              인센티브 지급
            </button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <div className='com_board_list__top'>
              <select className="select">
                <option value="이지수능 (본사)">이지수능 (본사)</option>
              </select>
            </div>
            <Calendar type="salary" />
            <hr className="com_divider" />
            <div className="salary_wrap">
              {/* 급여 명세서 */}
              <div className="receipt">
                <div className="detail_tit dot">3월 급여 명세서</div>
                <div className="scroll_wrap">
                  <table className='com_board_list'>
                    <colgroup>
                      <col width="50%"/><col width="20%"/><col width="30%"/>
                    </colgroup>
                    <thead>
                      <tr>
                        <th>+ 수수료 명</th>  
                        <th>회차</th>  
                        <th>금액</th>  
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>인정과목 수</th>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <th>관리 수수료</th>
                        <td>12회</td>
                        <td></td>
                      </tr>
                      <tr>
                        <th>미수금 외</th>
                        <td>12회</td>
                        <td></td>
                      </tr>
                      <tr>
                        <th>관리수수료 지급액</th>
                        <td>4회</td>
                        <td></td>
                      </tr>
                      <tr>
                        <th>장기특별관리 수수료</th>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <th>우수관리 특별 수수료</th>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <th>위험보전금</th>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <th>
                          <div className='input_receipt'>
                            <button className="btn_delete"></button>
                            <input type="text" className="input" placeholder="입력" />
                            <input type="text" className="input" placeholder="입력" />
                            <button className="btn_minus_black"></button>
                          </div>
                          <div className='input_receipt'>
                            <input type="text" className="input" placeholder="입력" />
                            <button className="btn_add_black"></button>
                          </div>
                        </th>
                        <td></td>
                        <td>
                          <input type="text" className="input" placeholder="입력" />
                        </td>
                      </tr>
                      <tr>
                        <th>총 인센티브 지급액</th>
                        <td></td>
                        <td className='td_point bold'>898,000</td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="com_btn_wrap right">
                    <button className="com_btn gray xs">+ 목록 추가</button>
                  </div>

                  {/* 공제 수수료 */}
                  <div className="detail_tit sub">* 공제 수수료</div>
                  <table className='com_board_list'>
                    <colgroup>
                      <col width="50%"/>
                    </colgroup>
                    <thead>
                      <tr>
                        <th>- 수수료 명</th>
                        <th>금액</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>사업소득세</th>
                        <td></td>
                      </tr>
                      <tr>
                        <th>사업주민세</th>
                        <td></td>
                      </tr>
                      <tr>
                        <th>세금 공제후 지급액</th>
                        <td></td>
                      </tr>
                      <tr>
                        <th>시책본인부담금</th>
                        <td></td>
                      </tr>
                      <tr>
                        <th>고용보험</th>
                        <td></td>
                      </tr>
                      <tr>
                        <th>산재보험</th>
                        <td></td>
                      </tr>
                      <tr>
                        <th>주차비</th>
                        <td></td>
                      </tr>
                      <tr>
                        <th>상조회비</th>
                        <td></td>
                      </tr>
                      <tr>
                        <th>선급금</th>
                        <td></td>
                      </tr>
                      <tr>
                        <th>
                          <div className='input_receipt'>
                            <button className="btn_delete"></button>
                            <input type="text" className="input" placeholder="입력" />
                            <input type="text" className="input" placeholder="입력" />
                            <button className="btn_minus_black"></button>
                          </div>
                          <div className='input_receipt'>
                            <input type="text" className="input" placeholder="입력" />
                            <button className="btn_add_black"></button>
                          </div>
                        </th>
                        <td>
                          <input type="text" className="input" placeholder="입력" />
                        </td>
                      </tr>
                      <tr>
                        <th>총 수수료 액</th>
                        <td className='td_point bold'>898,000</td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="com_btn_wrap right">
                    <button className="com_btn gray xs">+ 목록 추가</button>
                  </div>
                  {/* 총 지급액 */}
                  <table className='com_board_list type_row'>
                    <colgroup>
                      <col width="40%"/><col width="60%"/>
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>급여 총 지급액</th>
                        <td className='td_point bold'>898,000</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="com_btn_wrap center">
                  <button className="com_btn orange xs">인센티브 지급하기</button>
                </div>
              </div>
              
              {/* 수업 정산 승인 상세내역 */}
              <div className="detail">
                <div className="detail_tit dot">
                  3월 상세 내역
                </div>
                <table className='com_board_list'>
                  <thead>
                    <tr>
                      <th>학생명</th>
                      <th>소속</th>
                      <th>영역</th>
                      <th>회차 / T</th>
                      <th>상품가격</th>
                      <th>최근 입금일 
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>입금회차</th>
                      <th>진행 수업</th>
                      <th>입금 금액</th>
                      <th>환불 금액</th>
                      <th>최종 금액</th>
                      <th>홍보과목 수</th>
                      <th>정산금액 전달 </th>
                      <th>최종 정산금액</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <button className="btn_link">김학생103</button>
                      </td>
                      <td>화상</td>
                      <td>과탐</td>
                      <td>48회 / 2T</td>
                      <td>466,000</td>
                      <td>2023,02,25</td>
                      <td>16.5</td>
                      <td>5</td>
                      <td>1,000,000</td>
                      <td className="td_red">1,000</td>
                      <td className="td_point">78,000</td>
                      <td className="td_point">2</td>
                      <td>홍교사103<br/>5,000</td>
                      <td className="td_point">654,000</td>
                    </tr>
                    {[1,2,3,4,5,6,7,8,9,10].map((i,idx) => {
                      return (
                        <tr key={idx}>
                          <td>
                            <button className="btn_link">김학생103</button>
                          </td>
                          <td>화상</td>
                          <td>과탐</td>
                          <td>48회 / 2T</td>
                          <td>466,000</td>
                          <td>2023,02,25</td>
                          <td>16.5</td>
                          <td>5</td>
                          <td>1,000,000</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td>홍교사103<br/>5,000</td>
                          <td>654,000</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>

                <div className="com_btn_wrap right">
                  <button className="com_btn black xs btn_print">인쇄하기</button>
                  <button className="com_btn black xs btn_down_orange">다운로드</button>
                </div>
              </div>
            </div>
          </section>
        </section>
      </div>
      <PopRequestPoint open={modalOpen} close={() => setModalOpen(false)} />
    </main>
  );
}

export default AccountingIncentiveCheckDetail;
